// NGRX
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createFeatureSelector } from '@ngrx/store';

// CRUD
import { QueryParamsModel } from '../../_base/crud';
// Actions
import {
  AreaGroupActions,
  AreaGroupActionTypes,
} from '../_actions/area_group.actions';
// Models
import { AreaGroup } from '../_models/area_group.model';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface AreaGroupState extends EntityState<AreaGroup> {
  listLoading: boolean;
  actionsloading: boolean;
  totalCount: number;
  lastQuery: QueryParamsModel;
  lastCreatedAreaGroupId: number;
  showInitWaitingMessage: boolean;
}

export const adapter: EntityAdapter<AreaGroup> =
  createEntityAdapter<AreaGroup>();

export const initialAreaGroupState: AreaGroupState = adapter.getInitialState({
  listLoading: false,
  actionsloading: false,
  totalCount: 0,
  lastQuery: new QueryParamsModel({}),
  lastCreatedAreaGroupId: undefined,
  showInitWaitingMessage: true,
});

export function areaGroupReducer(
  state = initialAreaGroupState,
  action: AreaGroupActions
): AreaGroupState {
  switch (action.type) {
    case AreaGroupActionTypes.AreaGroupPageToggleLoading:
      return {
        ...state,
        listLoading: action.payload.isLoading,
        lastCreatedAreaGroupId: undefined,
      };

    case AreaGroupActionTypes.AreaGroupActionToggleLoading:
      return {
        ...state,
        actionsloading: action.payload.isLoading,
      };

    case AreaGroupActionTypes.AreaGroupPageCancelled:
      return {
        ...state,
        listLoading: false,
        lastQuery: new QueryParamsModel({}),
      };

    case AreaGroupActionTypes.AreaGroupUpsert:
      return adapter.upsertOne(action.payload.areaGroup, {
        ...state,
        lastCreatedAreaGroupId: action.payload.areaGroup.id,
      });

    case AreaGroupActionTypes.AreaGroupPageLoaded: {
      return adapter.addMany(action.payload.areaGroups, {
        ...initialAreaGroupState,
        totalCount: action.payload.totalCount,
        lastQuery: action.payload.page,
        listLoading: false,
        showInitWaitingMessage: false,
      });
    }

    default:
      return state;
  }
}

export const getAreaGroupState =
  createFeatureSelector<AreaGroupState>('areaGroups');

export const { selectAll, selectEntities, selectIds, selectTotal } =
  adapter.getSelectors();
